import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signup-main',
  templateUrl: './signup-main.component.html',
  styleUrls: ['./signup-main.component.scss']
})
export class SignupMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
